import { isAfter, isBefore, parseISO, endOfDay } from 'date-fns';

export const assessDateRange = (dateRange: {
    from: string | Date;
    to: string | Date;
}): 'past' | 'current' | 'future' => {
    const now = new Date();
    const fromDate = typeof dateRange.from === 'string' ? parseISO(dateRange.from) : dateRange.from;
    const toDate = typeof dateRange.to === 'string' ? parseISO(dateRange.to) : dateRange.to;

    return isBefore(now, fromDate) ? 'future' : isAfter(now, endOfDay(toDate)) ? 'past' : 'current';
};
